import React, { useState } from 'react';
import Header from './components/layout/Header';
import LeftMenuContext from './components/layout/LeftMenuContext';
// LeftMenuAgent削除 - 機能をエージェントビューに統合
import AIAssistantPanel from './components/layout/AIAssistantPanel';
// ChatInterfaceを削除（エージェントビューに統一）
// import ChatInterface from './components/shared/ChatInterface';
import MDAgent from './components/agents/MDAgent';
import PlanogramAgent from './components/agents/PlanogramAgent';
import MarketingAgent from './components/agents/MarketingAgent';
import CreativeAgent from './components/agents/CreativeAgent';
import InventoryOptimizer from './components/agents/InventoryOptimizer';
import AlertCenter from './components/agents/AlertCenter';
import DemandForecastAgent from './components/agents/DemandForecast';
import { ErrorBoundary } from './components/shared/ErrorBoundary';
import { SkipLink } from './components/shared/Accessibility';
import VersionInfo from './components/shared/VersionInfo';
import { I18nProvider } from './i18n';
import { 
  AgentId, 
  Environment, 
  DataSource, 
  // Message, // エージェントビューで使用
  JobStatus 
} from './types/agent.types';
// import { dialogueSamples } from './data/dialogueSamples'; // エージェントビューで使用
import { colors } from './constants/theme';

function App() {
  // 状態管理
  const [activeAgent, setActiveAgent] = useState<AgentId>('md');
  const [environment, setEnvironment] = useState<Environment>('prod');
  const [selectedStore, setSelectedStore] = useState('all');
  const [leftPanel1Open, setLeftPanel1Open] = useState(true);
  // leftPanel2Open削除 - サイドパネル機能をエージェントビューに統合
  const [rightPanelOpen, setRightPanelOpen] = useState(true);
  const [jobStatus, setJobStatus] = useState<JobStatus>('idle');
  // ビューモードは常にエージェントビューに固定
  
  // メッセージ管理はエージェントビュー内で処理
  // const [messages, setMessages] = useState<Record<AgentId, Message[]>>({
  //   demand: dialogueSamples.demand || [],
  //   md: dialogueSamples.md || [],
  //   planogram: dialogueSamples.planogram || [],
  //   marketing: dialogueSamples.marketing || [],
  //   creative: dialogueSamples.creative || [],
  //   planning: dialogueSamples.planning || [],
  //   dashboard: [],
  //   inventory: dialogueSamples.inventory || [],
  //   alerts: dialogueSamples.alerts || []
  // });

  // データソース（モックデータ）
  const dataSources: DataSource[] = [
    { name: 'POS', status: 'connected', records: '2.3M', sync: '10分前' },
    { name: 'ID-POS', status: 'connected', records: '890K', sync: '15分前' },
    { name: '在庫', status: 'connected', records: '145K', sync: '5分前' },
    { name: '商品マスター', status: 'delayed', records: '23K', sync: '1時間前' },
    { name: '価格・販促', status: 'connected', records: '45K', sync: '30分前' }
  ];

  // メッセージ送信処理（エージェントビュー内で処理）
  // const handleSendMessage = (content: string) => {
  //   const newMessage: Message = {
  //     type: 'user',
  //     content,
  //     timestamp: new Date()
  //   };
  //   
  //   setMessages(prev => ({
  //     ...prev,
  //     [activeAgent]: [...prev[activeAgent], newMessage]
  //   }));
  //   
  //   // AIレスポンスのシミュレーション
  //   setJobStatus('processing');
  //   setTimeout(() => {
  //     const aiResponse: Message = {
  //       type: 'ai',
  //       content: `「${content}」についての分析を開始しました。\n\n処理中です...`,
  //       timestamp: new Date()
  //     };
  //     
  //     setMessages(prev => ({
  //       ...prev,
  //       [activeAgent]: [...prev[activeAgent], aiResponse]
  //     }));
  //     
  //     // 結果のシミュレーション
  //     setTimeout(() => {
  //       const resultMessage: Message = {
  //         type: 'result',
  //         content: {
  //           summary: '分析が完了しました',
  //           kpis: {
  //             '処理時間': '2.3秒',
  //             '精度': '95%',
  //             '改善率': '+18%',
  //             'ROI': '320%'
  //           }
  //         },
  //         timestamp: new Date()
  //       };
  //       
  //       setMessages(prev => ({
  //         ...prev,
  //         [activeAgent]: [...prev[activeAgent], resultMessage]
  //       }));
  //       
  //       setJobStatus('completed');
  //     }, 2000);
  //   }, 1000);
  // };

  return (
    <ErrorBoundary>
      <I18nProvider>
        <div className="flex flex-col h-screen bg-white">
          {/* アクセシビリティ: スキップリンク */}
          <SkipLink />
          
          {/* ヘッダー */}
          <Header
            activeAgent={activeAgent}
            setActiveAgent={setActiveAgent}
            environment={environment}
            setEnvironment={setEnvironment}
          />

          {/* メインコンテンツ */}
          <main id="main-content" className="flex flex-1 overflow-hidden">
        {/* 左サイドバー1: コンテキスト */}
        <LeftMenuContext
          isOpen={leftPanel1Open}
          setIsOpen={setLeftPanel1Open}
          selectedStore={selectedStore}
          setSelectedStore={setSelectedStore}
          dataSources={dataSources}
        />

        {/* 左サイドバー2削除 - 機能をエージェントビューに統合 */}

        {/* 中央: エージェントビュー */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* エージェントビューのみ表示 */}
          {activeAgent === 'demand' && <DemandForecastAgent />}
          {activeAgent === 'md' && <MDAgent />}
          {activeAgent === 'planogram' && <PlanogramAgent />}
          {activeAgent === 'creative' && <CreativeAgent />}
          {activeAgent === 'marketing' && <MarketingAgent />}
          {activeAgent === 'inventory' && <InventoryOptimizer />}
          {activeAgent === 'alerts' && <AlertCenter />}
        </div>

        {/* 右サイドバー: AIアシスタント */}
        <AIAssistantPanel
          isOpen={rightPanelOpen}
          setIsOpen={setRightPanelOpen}
          activeAgent={activeAgent}
        />
          </main>
          
          {/* バージョン情報 */}
          <VersionInfo />
        </div>
      </I18nProvider>
    </ErrorBoundary>
  );
}

export default App;
